module.exports = __webpack_public_path__ + "a8d3c61e3e233032b05f2f5be5b01f06.png";